/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/page-faq.js":
/*!****************************!*\
  !*** ./src/js/page-faq.js ***!
  \****************************/
/***/ (() => {

eval("//import gsap from 'gsap';\n//import ScrollTrigger from 'gsap/ScrollTrigger';\n//gsap.registerPlugin(ScrollTrigger);\ndocument.querySelectorAll('.faq-category__anchor').forEach(function (el) {\n  var id = el.getAttribute('id');\n  var title = el.getAttribute('data-title');\n  var item = document.createElement('li');\n  var link = document.createElement('a');\n  var span = document.createElement('span');\n  link.href = \"#\".concat(id);\n  span.innerText = title;\n  link.appendChild(span);\n  item.appendChild(link);\n  document.querySelector('.faq-main__tab-links').appendChild(item);\n});\n$('.faq-category__toggle').on('click', function () {\n  var $target = $(this).closest('.faq-main');\n  $('.faq-main.active').not($target).removeClass('active');\n  $target.toggleClass('active');\n}); //ScrollTrigger.matchMedia({\n//  \"(min-width: 992px)\": function() {\n//    const offset = $('.navbar').height() + 70;\n// const offsetBottom = $('.faq-main__tab-links').height() + offset + 100;\n//    const ST = ScrollTrigger.create({\n//      trigger: '.faq-main__left--sticky',\n//      endTrigger: '.faq-contact',\n//      start: `${ -offset } top`,\n//      end: `top bottom`,\n//      pin: true,\n//      pinSpacing: false,\n////    })\n// }\n//})\n\n//# sourceURL=webpack://nightworks/./src/js/page-faq.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/js/page-faq.js"]();
/******/ 	
/******/ })()
;